import { dateConvertTimezone } from "src/app/platform/utils/functions";

export class ProductsData {
    id: number;
    product: ProductsTypeData;
    politic: ProductsPoliticData;
    vendor: string;
    status: string;
    dateStart: string;
    dateInstall: string;
    isRemovable: boolean;
    isReplaceable: boolean;

    constructor() {
        this.id = 0;
        this.product = new ProductsTypeData();
        this.politic = new ProductsPoliticData();
        this.vendor = '';
        this.status = '';
        this.dateStart = '';
        this.dateInstall = '';
        this.isRemovable = false;
        this.isReplaceable = false;
    }

    configData(parameters: any): ProductsData{
        this.id = parameters.id;
        this.product = new ProductsTypeData().configData(parameters.producto);
        this.politic = new ProductsPoliticData().configData(parameters.politica);
        this.vendor = parameters.promotorNombre;
        this.status = parameters.estado;
        this.dateStart = dateConvertTimezone(new Date(parameters.fechaIngreso), 'Etc/Greenwich');
        this.dateInstall = dateConvertTimezone(new Date(parameters.fechaInstalacion), 'Etc/Greenwich');
        this.isRemovable = parameters.permiteBaja;
        this.isReplaceable = parameters.productoReemplazable;

        return this;
    }
}

export class ProductsTypeData {
    id: number;
    name: string;
    profile: string;

    constructor() {
        this.id = 0;
        this.name = '';
        this.profile = '';
    }

    configData(parameters: any): ProductsTypeData {
        this.id = parameters.id;
        this.name = parameters.nombre;
        this.profile = parameters.perfil;

        return this;
    }
}

export class ProductsPoliticData {
    id: number;
    name: string;

    constructor() {
        this.id = 0;
        this.name = '';
    }

    configData(parameters: any): ProductsPoliticData {
        this.id = parameters.id;
        this.name = parameters.nombre;

        return this;
    }
}
